import { getPath } from '@/router/common'

const baseUrl = {
  title: '仓储导入模板管理',
  path: 'ImportWarehouse'
}

export default [
  {
    path: getPath('MaterialIndex', baseUrl),
    name: 'MaterialIndex',
    component: () => import(/* webpackChunkName: "MaterialIndex" */ '@/views/importWarehouse/materialIndex/index.vue'),
    meta: {
      title: '仓储-物料编码导入'
    }
  },
  {
    path: getPath('MaterialDetails', baseUrl),
    name: 'MaterialDetails',
    component: () => import(/* webpackChunkName: "MaterialDetails" */ '@/views/importWarehouse/materialDetails/index.vue'),
    meta: {
      title: '导入物料编码明细'
    }
  },
  {
    path: getPath('Index', baseUrl),
    name: 'importWarehouse_Index',
    component: () => import(/* webpackChunkName: "importWarehouse_Index" */ '@/views/importWarehouse/index/index.vue'),
    meta: {
      title: '仓储导入'
    }
  },
  {
    path: getPath('Details', baseUrl),
    name: 'Details',
    component: () => import(/* webpackChunkName: "Details" */ '@/views/importWarehouse/details/index.vue'),
    meta: {
      title: '仓储导入明细'
    }
  },
  {
    path: getPath('indetail', baseUrl),
    name: 'indetail',
    component: () => import(/* webpackChunkName: "indetail" */ '@/views/warehouseManagement/indetail/index.vue'),
    meta: {
      title: '进仓明细'
    }
  },
  {
    path: getPath('Delivery_Index', baseUrl),
    name: 'Delivery_Index',
    component: () => import(/* webpackChunkName: "Delivery_Index" */ '@/views/importWarehouse/delivery_Index/index.vue'),
    meta: {
      title: '出仓导入'
    }
  },
  {
    path: getPath('Delivery_Details', baseUrl),
    name: 'Delivery_Details',
    component: () => import(/* webpackChunkName: "Delivery_Details" */ '@/views/importWarehouse/delivery_Details/index.vue'),
    meta: {
      title: '仓储-出仓导入(订单)'
    }
  }
]
